import Vue from 'vue'

Vue.filter('striptags', (str) => {
  const div = document.createElement('div')
  div.innerHTML = str
  return div.innerText
})
